import { Grid } from '@mui/material';
import React from 'react';

interface SettingsFieldCardProps {
    children: React.ReactNode;
}

export const SettingsFieldCard: React.FC<SettingsFieldCardProps> = ({ children }) => {
    return (
        <Grid container sx={{ width: 800, borderRadius: 2, padding: 2, border: 1, flexDirection: "row", borderColor: "divider", mt: 3 }}>
            {children}
        </Grid>
    );
};
